import React from "react";
import { cn } from "@/lib/utils";
import { getInitials } from "@/shared/utils/getInitials";

const SIZE_CLASSES = {
  sm: "h-6 w-6 text-[9px]",
  md: "h-9 w-9 text-xs",
} as const;

interface UserAvatarProps {
  name: string | null | undefined;
  email?: string | null;
  size?: "sm" | "md";
  className?: string;
  title?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  email = null,
  size = "md",
  className,
  title,
}) => {
  const initials = getInitials(name, email);
  const label = title ?? name ?? email ?? "User";

  return (
    <span
      title={label}
      aria-label={label}
      className={cn(
        "inline-flex items-center justify-center rounded-full font-semibold uppercase tracking-wide text-white shrink-0 select-none",
        SIZE_CLASSES[size],
        className,
      )}
    >
      {initials}
    </span>
  );
};
